import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Modules } from 'src/app/_common/_enum/module.enum';
import { AuthenticationService } from 'src/app/user/_services/authentication.service';
import { MessageService } from '../_services/message.service';
import { RESULTS_NOT_FOUND } from 'src/app/_common/product-config';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  loading = false;
  private messages;
  private outageMessages;
  //private showQuickAccess: boolean = false;

  resultsNotFound = RESULTS_NOT_FOUND;

  constructor(private router: Router, private authenticationService: AuthenticationService, private messageService: MessageService) { }

  ngOnInit() {
    console.log("entered dashboard");
    this.getMessages();
  }

  getMessages(){
    this.loading = true;
    this.messageService.getMessages().subscribe(data=>{
      this.loading = false;
      this.messages = data.messages;
      this.outageMessages = data.outageMessages;
    },
    error=>{
      this.loading = false;
      this.messages = null;
      this.outageMessages = null;
    });
  }
  goToMessages(){
    this.router.navigateByUrl("/messages");
  }
  
  get ModuleEnum(){
    return Modules;
  }
  private accessURL(moduleName: string){ //Using method from HTML
    return this.authenticationService.getModule(moduleName).link;
  }
}
